const submitButtonConfig = {
    enabled: true,
    text: 'Save',
    tooltip: 'Submit your work and move to next task'
};
const addApprovalButtonConfig = {
    enabled: false,
    text: 'Add Approval',
    tooltip: 'Approve the workitem'
};
const approvedButtonConfig = {
    enabled: false,
    text: 'Approved',
    tooltip: 'Approved',
    classNames: [
        'success-button'
    ],
    icon: 'BiomeCheckSVG20'
};
var CQAStatus = /*#__PURE__*/ function(CQAStatus) {
    CQAStatus["IN_CQA"] = "IN_CQA";
    CQAStatus["CQA_COMPLETE"] = "CQA_COMPLETE";
    CQAStatus["CQA_APPROVED"] = "CQA_APPROVED";
    return CQAStatus;
}(CQAStatus || {});
export function getUserRolesFromActiveContext(data) {
    if (!data || !data.activeContext || !data.user || !data.user.roles) {
        return [];
    }
    const tenantId = data.activeContext.tenantId;
    // Find the matching roles object in user.roles array
    const matchingRole = data.user.roles.find((role)=>role.tenantId === tenantId);
    // Extract role names into an array
    return matchingRole ? matchingRole.roles.map((r)=>r.roleName) : [];
}
export const getIsAuditor = (gradeBenchPanelState, roles, workerId)=>{
    const auditors = gradeBenchPanelState.qaRule.data?.project_configuration?.auditors;
    if (auditors && auditors.length > 0 && workerId) {
        if (auditors.includes(workerId)) {
            return true;
        }
    } else {
        return roles.includes('cqa_manager');
    }
    return false;
};
export const getSubmitButtonConfig = (gradeBenchPanelState, roles, workerId)=>{
    if (gradeBenchPanelState.invoices.length > 0 && gradeBenchPanelState.invoices[0].status === "IN_CQA") {
        return {
            ...submitButtonConfig,
            enabled: true
        };
    }
    const approveEnabled = getIsAuditor(gradeBenchPanelState, roles, workerId);
    if (gradeBenchPanelState.invoices.length > 0 && gradeBenchPanelState.invoices[0].status === "CQA_COMPLETE") {
        return {
            ...addApprovalButtonConfig,
            enabled: approveEnabled
        };
    }
    if (gradeBenchPanelState.invoices.length > 0 && gradeBenchPanelState.invoices[0].status === "CQA_APPROVED") {
        return approvedButtonConfig;
    }
    return submitButtonConfig;
};
